module.exports = __webpack_public_path__ + "img/00—01—Login—IBstandard.48e8c4d6.jpg";